<template>
  <nna-container :spacing=20 bottom-bar-active>
    <orders-list />
  </nna-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OrdersList from '@/modules/common/components/list/Orders'
export default {
  name: 'Orders',
  components: {
    OrdersList
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      shop: 'shops/current',
    }),
  },
  methods: {
    ...mapActions({      
    }),
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/Order/pages/Orders.vue